import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import axios from 'axios';
import Popup from "reactjs-popup";
import AdvertisingEnquiry from './AdvertisingEnquiry';
import AdComponent from './AdComponent';
import Subscription from './Subscription';

import './styles/App.css';
import './styles/model.css';

var Spinner = require('react-spinkit');

class Model extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: {},
      loaded: false,
    }
  }

  componentDidMount() {
    axios.get(process.env.REACT_APP_API + '/api/models/' + this.props.match.params.slug + "/")
      .then((response) => {
        this.setState({model: response.data, loaded: true});
    });
  }

  render() {
    const paperLinks = this.state.model.papers ? Object.keys(this.state.model.papers).map((paper_title) => 
      <li><Link to={this.state.model.papers[paper_title]} target="_blank">{paper_title}</Link></li>
    ) : "";

    const framework = this.props.frameworks[this.state.model.framework];
    const frameworkLink = framework ? <Link to={"/framework/" + framework.slug} className="btn btn-primary">{framework.title}</Link> : <p></p>;
    const plainFrameworkLink = framework ? <Link to={"/framework/" + framework.slug}>{framework.title}</Link> : <p></p>;
    const categories = this.state.model.categories ? this.state.model.categories.map((category) =>
        <a key={this.state.model.slug + "-category-" + category.slug} href={"/category/" + category.slug} className="btn btn-category">{category.short_title}</a>
      ) : "";
    const plainCategories = this.state.model.categories ? this.state.model.categories.map((category, index) =>
        // Show a comma if it's not the last category
        <span key={this.state.model.slug + "-plain-category-" + category.slug}><Link to={"/category/" + category.slug}>{category.short_title}</Link>{ index < this.state.model.categories.length - 1 ? ", " : "" }</span>
      ) : "";
    const stars = this.state.model.stars ? this.state.model.stars : "";

    return (
      <section className="row" align="center">
      <Helmet>
        <title>Model Zoo - {this.state.model.title ? this.state.model.title : ""} { framework ? framework.title : "" } Model</title>
        { this.state.model.description ? <meta name="description" content={this.state.model.description} /> : "" }
      </Helmet>
      <div className="col-md-8 model" align="left">
        <h1 className="card-title">{ this.state.model.title ? this.state.model.title : "Loading..."}</h1>
        <p className="card-text" dangerouslySetInnerHTML={{__html: this.state.model.description}}></p>
        {frameworkLink}<br/>

        <div className="categories-div">
        {categories}
        </div>
        <hr/>

        { this.state.loaded ? "" : <Spinner name="three-bounce" fadeIn="none" /> }
        { this.state.model.long_desc ? 
        <div className="content" dangerouslySetInnerHTML={{__html: this.state.model.long_desc}}></div>
        : <p>No information available.</p> }
        <br/>
      </div>
      <div className="col-md-4">
        <div className="model-info-div box-shadow">
          <h3>Details</h3>
          <strong>Framework:</strong> { plainFrameworkLink }<br/>
          <strong>Categories:</strong> { plainCategories.length > 0 ? plainCategories : "-" }<br/>
          <strong>GitHub Stars:</strong> { stars } <br/>

          { this.state.model.link ? 
            <span>
            <hr />
            <Link to={this.state.model.link} target="_blank" className="btn btn-primary btn-get-model">Get Model</Link>
            </span> : ""
          }
        </div>
        <br/>
        { paperLinks ? 
          <div className="model-paper-div box-shadow">
          <h3>Papers Mentioned</h3>
          <ul className="">
          { paperLinks }
          </ul>
          </div>
        : ""
        }
        { paperLinks ? <br/> : ""
        }

        { process.env.REACT_APP_DO == 1 ? <div className="advertisement-div"><a href="https://m.do.co/c/22076f5f712e" target="_blank" rel="nofollow"><img title="ModelZoo is Powered by DigitalOcean!" src={process.env.PUBLIC_URL + '/media/images/digitalocean.png'} /></a></div> : "" }

        <div className="advertisement-div"><AdComponent /></div>
        <br/>

        { process.env.REACT_APP_ADVERTISE_BTN == 1 ? <div className="advertisement-div"><Popup trigger={<a href="#">Advertise with us!</a>} modal closeOnDocumentClick><AdvertisingEnquiry /></Popup></div> : "" }

        <Subscription />

      </div>
      </section>
    )
  }
}

export default Model;


// WEBPACK FOOTER //
// ./src/Model.jsx